import React, {FC, useEffect} from "react";
import Checkers from "../../../../helpers/class/Checkers";
import {raw} from "express";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAngleRight} from "@fortawesome/pro-solid-svg-icons";

interface BedsArrangementProps {
    data: any
}
const BedsArrangement: FC<BedsArrangementProps> = ({data} ) => {

    return (
        <>
            {
                <>
                    <div className="block-title p-b-15 text-black">
                        Beds&nbsp;<FontAwesomeIcon className="me-2" icon={faAngleRight}/>
                    </div>
                    <ul className={'row m-b-20'}>
                        {
                            data.bedroom_beds_king != null && data.bedroom_beds_king != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        King:&nbsp;{data.bedroom_beds_king}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_beds_queen != null && data.bedroom_beds_queen != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Queen:&nbsp;{data.bedroom_beds_queen}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_beds_double != null && data.bedroom_beds_double != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Double:&nbsp;{data.bedroom_beds_double}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_beds_single != null && data.bedroom_beds_single != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Single:&nbsp;{data.bedroom_beds_single}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_beds_sofabed != null && data.bedroom_beds_sofabed != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Sofabed:&nbsp;{data.bedroom_beds_sofabed}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_beds_murphy != null && data.bedroom_beds_murphy != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Murphy beds:&nbsp;{data.bedroom_beds_murphy}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_bunk != null && data.bedroom_bunk != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Bunk:&nbsp;{data.bedroom_bunk}
                                    </li>
                                </>
                                :
                                <></>
                        }
                        {
                            data.bedroom_baby_cribs != null && data.bedroom_baby_cribs != "0" ?
                                <>
                                    <li className={'col-md-6'}>
                                        Baby cribs:&nbsp;{data.bedroom_baby_cribs}
                                    </li>
                                </>
                                :
                                <></>
                        }
                    </ul>
                </>
            }
        </>
    )
}

export default BedsArrangement